import { render, staticRenderFns } from "./ACTAAGTP.vue?vue&type=template&id=16808aeb&scoped=true"
import script from "./ACTAAGTP.vue?vue&type=script&lang=js"
export * from "./ACTAAGTP.vue?vue&type=script&lang=js"
import style0 from "./ACTAAGTP.vue?vue&type=style&index=0&id=16808aeb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16808aeb",
  null
  
)

export default component.exports